import ApiService from './api.service'

const DonationService = {
    getRecentDonations: async function(limit = 20, schoolId = null) {
        ApiService.setXAuthorizationHeader();
        let url = `donations/recent?limit=${limit}`;
        if (schoolId) {
            url += `&school_id=${schoolId}`;
        }
        const response = await ApiService.get(url);
        return response.data.data || [];
    }
}

export default DonationService

export { DonationService }
